import { useEffect, useState } from "react";

export default function useGlobalFontUrl() {
  const [fontsSrc, setFontsSrc] = useState("");

  useEffect(() => {
    const linkElement = window.document.getElementById("font-css");
    if (!linkElement) {
      console.error("Font <link> element not found");
    } else {
      setFontsSrc(linkElement.getAttribute("href") || "");
    }
  }, []);

  return fontsSrc;
}
